export const configs = {
  baseUrl: process.env.REACT_APP_DB_URL,
  uploadImg: process.env.REACT_APP_ADD_IMG,
  ad: process.env.REACT_APP_ROLL_ADMIN,
  mng: process.env.REACT_APP_ROLL_MANAGER,
  prog: process.env.REACT_APP_ROLL_PROGRAMIST,
  sk: process.env.REACT_APP_ROLL_SKLAD,
};
